const sortSelectOptions = [
  {
    label: 'Name (A-Z)',
    value: 'nameAZ',
  },
  {
    label: 'Name (Z-A)',
    value: 'nameZA',
  },
];

const sortByOptionToOrderMap = {
  nameAZ: {
    orderBy: 'name',
    order: 'asc',
  },
  nameZA: {
    orderBy: 'name',
    order: 'desc',
  },
} as const satisfies Record<
  (typeof sortSelectOptions)[number]['value'],
  { orderBy: string; order: 'asc' | 'desc' }
>;

type SortMapOrderBy =
  (typeof sortByOptionToOrderMap)[keyof typeof sortByOptionToOrderMap]['orderBy'];

const isValidSortKey = (
  value: string,
): value is keyof typeof sortByOptionToOrderMap =>
  Object.prototype.hasOwnProperty.call(sortByOptionToOrderMap, value);

export default function useBulkRevaluationsSort(pagination: {
  orderBy: SortMapOrderBy;
  order: 'asc' | 'desc';
  handleChangeSort: (orderBy: SortMapOrderBy, order: 'asc' | 'desc') => void;
}) {
  const sortSelectValue = Object.entries(sortByOptionToOrderMap).find(
    ([_, option]) =>
      option.orderBy === pagination.orderBy &&
      option.order === pagination.order,
  )?.[0];

  const handleChangeSort = (value: string) => {
    if (!isValidSortKey(value)) return;
    const { orderBy, order } = sortByOptionToOrderMap[value];
    pagination.handleChangeSort(orderBy, order);
  };

  return {
    sortSelectOptions,
    sortSelectValue: sortSelectValue ?? 'nameAZ',
    handleChangeSort,
  };
}
